export default "__VITE_ASSET__D$oM8Xmj__"